import { PAGE_NAMES } from "../../system/constants";

const initialState = PAGE_NAMES.HOME;

const pageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PAGE_NAME": {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default pageReducer;
